import { render, staticRenderFns } from "./GerenciaCadastroItinerariosFormativos.vue?vue&type=template&id=0837fc28"
import script from "./GerenciaCadastroItinerariosFormativos.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroItinerariosFormativos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports